import { AppBar, Container, IconButton, Toolbar } from "@material-ui/core"
import { LargeScreen, MediumScreen, Mobile } from "common/MediaQueries"
import MainMcdIcon from "components/Icons/MainMcdIcon"
import NextLink from "components/Reusable/Bit/NextLink"
import { StyledButtonPrimary } from "components/Reusable/Buttons"
import Image from "next/image"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import styled from "styled-components"
import BurgerNavigation from "./BurgerNavigation"

const StyledAppBar = styled(AppBar)`
  height: 106px;
  position: fixed;
  background-color: transparent;
  pointer-events: none;
  span:has(.bgImage) {
    overflow: visible !important;
  }
  .bgImage {
    filter: drop-shadow(0px 5px 15px #0000000a);
  }
  > * {
    pointer-events: auto;
  }
`

const StyledContainer = styled(Container)`
  padding: 15px 16px;
  max-width: none;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 16px 60px;
  }
`

const StyledToolbar = styled(Toolbar).attrs({ disableGutters: true })`
  justify-content: space-between;
  min-height: auto;
  align-items: center;
`

const StyledBox = styled.div`
  padding: 0px;
  width: auto;
  background-color: transparent;
  a {
    padding: 0;
  }
  :hover {
    background-color: transparent;
  }
`

const StyledButton = styled(StyledButtonPrimary).attrs({ size: "small" })`
  margin-right: 32px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-right: 16px;
  }
`

const StyledIconButton = styled(IconButton).attrs({
  "aria-label": "לוגו מקדונלדס, מעבר לעמוד הבית של אתר הגיפטקארד",
})`
  padding: 0;
`

const StyledBurgerIconButton = styled(IconButton)`
  padding: 0;

  .nav_toggle_button {
    display: flex;
    gap: 0.5rem;
    font-weight: 700;
    user-select: none;
    -webkit-user-select: none;
    transform: translateZ(0);
  }

  .nav_toggle_button_icon {
    position: relative;
    width: 1.6rem;
    height: 1.6rem;
  }

  .nav_toggle_button_icon_bar {
    position: absolute;
    display: block;
    width: 100%;
    height: 16%;
    background: #ffbc0f;
    transition: transform 0.2s, top 0.2s, bottom 0.2s, all 0.2s;
  }

  .nav_toggle_button_icon_bar_1 {
    top: 0;
    transform: rotate(2.5deg);
  }

  .nav_toggle_button_icon_bar_2 {
    top: 28%;
  }

  .nav_toggle_button_icon_bar_3 {
    bottom: 28%;
    transform: rotate(4.5deg);
  }

  .nav_toggle_button_icon_bar_4 {
    bottom: 0;
    transform: rotate(-5.5deg);
  }

  .nav_toggle_button_icon.active_menu {
    .nav_toggle_button_icon_bar {
      top: 50%;
      bottom: 50%;
    }
    .nav_toggle_button_icon_bar_1,
    .nav_toggle_button_icon_bar_3 {
      transform: rotate(45deg);
    }
    .nav_toggle_button_icon_bar_2,
    .nav_toggle_button_icon_bar_4 {
      transform: rotate(-45deg);
    }
  }
`

const StyledBgImageWrap = styled.div`
  pointer-events: none;
`

const Header = () => {
  const router = useRouter()
  const [navIsOpen, setNavIsOpen] = useState(false)
  useEffect(() => {
    setNavIsOpen(false)
  }, [router.pathname])
  return (
    <StyledAppBar>
      <BurgerNavigation isOpen={navIsOpen} />
      <StyledBgImageWrap>
        <LargeScreen>
          <Image
            src={"/headerBG.png"}
            layout="fill"
            className="bgImage"
            style={{ pointerEvents: "none" }}
          />
        </LargeScreen>
        <MediumScreen>
          <Image
            src={"/headerBG.png"}
            layout="fill"
            className="bgImage"
            style={{ pointerEvents: "none" }}
          />
        </MediumScreen>
        <Mobile>
          <Image
            src={"/headerBgMobile.png"}
            layout="fill"
            className="bgImage"
            style={{ pointerEvents: "none" }}
          />
        </Mobile>
      </StyledBgImageWrap>
      <StyledContainer>
        <StyledToolbar>
          <StyledBox>
            <StyledBurgerIconButton
              onClick={() => setNavIsOpen((prev) => !prev)}
              aria-label={`${navIsOpen ? "סגירת תפריט" : "פתיחת תפריט "}`}
              aria-expanded={navIsOpen}
            >
              <span
                className={`nav_toggle_button_icon ${
                  navIsOpen && "active_menu"
                }`}
              >
                <span className="nav_toggle_button_icon_bar nav_toggle_button_icon_bar_1"></span>
                <span className="nav_toggle_button_icon_bar nav_toggle_button_icon_bar_2"></span>
                <span className="nav_toggle_button_icon_bar nav_toggle_button_icon_bar_3"></span>
                <span className="nav_toggle_button_icon_bar nav_toggle_button_icon_bar_4"></span>
              </span>
            </StyledBurgerIconButton>
            <StyledButton
              aria-label="מעבר לצורך ביצוע הזמנה באתר ההזמנות"
              onClick={() => router.push("/companies")}
            >
              לעסקים
            </StyledButton>
          </StyledBox>

          <NextLink href="/" ariaLabel="מעבר לעמוד הבית" passHref>
            <StyledIconButton>
              <MainMcdIcon />
            </StyledIconButton>
          </NextLink>
        </StyledToolbar>
      </StyledContainer>
    </StyledAppBar>
  )
}

export default Header
